function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-location_svg__prefix-icon-location-2{fill:#fff}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon-location_svg__Group_1859",
  "data-name": "Group 1859",
  transform: "translate(-375 -346)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-location_svg__Group_1847",
  "data-name": "Group 1847",
  transform: "translate(0 43)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "icon-location_svg__Ellipse_73",
  cx: 11,
  cy: 11,
  r: 11,
  fill: "#202cb9",
  "data-name": "Ellipse 73",
  transform: "translate(375 303)"
})), /*#__PURE__*/React.createElement("g", {
  id: "icon-location_svg__Group_1851",
  "data-name": "Group 1851",
  transform: "translate(457.249 303.471)"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon-location_svg__Path_1269",
  d: "M-71.249 47.529a5.005 5.005 0 00-5 5c0 1.146.712 2.69 2.177 4.72a33.754 33.754 0 002.051 2.559l.483.536a.389.389 0 00.289.128.389.389 0 00.29-.128l.482-.536a33.096 33.096 0 002.051-2.559c1.465-2.03 2.177-3.574 2.177-4.72a5.005 5.005 0 00-5-5zm2.191 9.263a31.557 31.557 0 01-2 2.493l-.193.214-.193-.214c-.01-.011-1-1.11-2-2.493-1.346-1.866-2.029-3.3-2.029-4.264a4.225 4.225 0 014.22-4.22 4.226 4.226 0 014.221 4.22c.004.963-.679 2.398-2.026 4.264z",
  className: "icon-location_svg__prefix-icon-location-2",
  "data-name": "Path 1269"
}), /*#__PURE__*/React.createElement("circle", {
  id: "icon-location_svg__Ellipse_90",
  cx: 1.456,
  cy: 1.456,
  r: 1.456,
  className: "icon-location_svg__prefix-icon-location-2",
  "data-name": "Ellipse 90",
  transform: "translate(-72.704 51.025)"
})));

function SvgIconLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22"
  }, props), _ref, _ref2);
}

export default SvgIconLocation;